<template>
    <div class="cents">
        <van-nav-bar
        :title="this.$t('sb')"
		:right-text="UserInfo.person_type == 2 ? this.$t('tj') :''"
        left-arrow
        safe-area-inset-top
        style="background-color: #1ABC9C;"
        @click-left="goto"
		@click-right="goSearch"
        />
        <div class="requist">
            <van-field
            :border="true"
            clearable
            size='large'
            v-model="keyword"
            :placeholder="$t('sbmhzwz')"
            />
            <van-button color="#1ABC9C" size="small" @click="questlist">{{$t('cxwz')}}1</van-button>
        </div>
        <div class="equtcont">
            <!-- <h4>风华一区</h4> -->
           <!-- <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="$t('mygd')"
                @load="onLoad"
            > -->
                <div class="" v-for="(item,index) in equdatalist" :key="item.id">
                    <div class="costplas " >
                        <div :class="item.is_online? 'yuan colorsold ': 'yuan colors' " @click="handleDevice(item.serial_number,index)">
                            <!-- <h2>{{item.is_online?'在线':'离线'}}</h2> -->
                            <van-icon name="wap-home" />
                        </div>
                    <div style="text-align: left;">
                        
                            <p style="line-height:30px">{{weiz}}:{{item.name}}</p>
                            <p>{{xlh}}:{{item.serial_number}}</p>
                    </div>
                    </div>
                </div>
            <!-- </van-list> -->
        </div>
        <!-- 分页 -->
        <div class="data-load-more" v-if="deviceCount>10||Math.ceil(deviceCount/page_size)>1">
        	<div @click="goTop">{{this.$t('syy')}}</div>
        	<div style="width: 25px;" @click="pageTop" v-if="pageSizeList[0]!=1">...</div>
        	<div class="pageSizeBox">
        		<div v-for="(item,index) in pageSizeList" :key="index" style="width: 25px;" @click="handlePageSize(item)" :class="[page_index==item?'pageSizeItemState':'']">
        			{{item>pageSize?'':item}}
        		</div>
        	</div>
        	<div style="width: 25px;" @click="pageBottom" v-if="pageSize>pageSizeList[4]">...</div>
        	<div @click="goBottom">{{this.$t('xyy')}}</div>
        </div>
        <div style="padding-bottom:80px">

        </div>
        <Footer :person_type="UserInfo.person_type"></Footer>  
    </div>
</template>
<script>
export default {
    data(){
        return{
            loading:false,
            finished: false,
            UserInfo:JSON.parse(window.localStorage.getItem("getTokendata")),
            page_size:10,
            keyword:"",
            equdatalist:[],
            page_index:1,
            count:null,
            weiz:this.$t('sbwz'),
            xlh:this.$t('xlh'),
			deviceCount:0, // 接口返回设备数量
			pageSize:0, // 设备页数
			pageSizeList:[1,2,3,4,5], // 页码
        }
    },
    mounted(){
        this.getEquiplist()
    },
    methods:{
		// 点击装置
		handleDevice(e,index) {
            
            // return false
			if(this.UserInfo.person_type == 2){
                let equdatalistDate = JSON.stringify(this.equdatalist[index])
                // console.log(e,index,equdatalistDate)
				this.$router.push({path:'/netlist',query:{serial_number:e,deviceInfo:equdatalistDate}})
			}
			// this.$router.push(`/netlist?serial_number=${e},deviceInfo=${equdatalistDate}`)
		},
		// 搜索设备 页面
		goSearch(){
			this.$router.push('/deviceSearch')
		},
        goto(){
            this.$router.go(-1)
        },
		// 页码点击
		handlePageSize(index){
			console.log(index,this.pageSize);
			console.log(this.page_index);
			 if(index>this.pageSize){
				return
			};
			this.page_index = index;
			this.getEquiplist()
		},
		// 上个页码
		pageTop(){
			let pageArr = []
			this.pageSizeList.forEach(item=>{
			  item-=5
			  pageArr.push(item)
			})
			this.pageSizeList = pageArr;
		},
		// 下页码
		pageBottom(){
			let pageArr = []
			this.pageSizeList.forEach(item=>{
			  item+=5
			  pageArr.push(item)
			})
			this.pageSizeList = pageArr
		},
		// 上一页
		goTop(){
			if(this.deviceCount==0){
			  return
			};
			if(this.page_index==1){
			  this.$message.info(this.$t('ysdyy'))
			  return
			};
			this.page_index--;
			if(this.page_index<this.pageSizeList[0]){
				let pageArr = []
				this.pageSizeList.forEach(item=>{
				item-=5
				pageArr.push(item)
				})
				this.pageSizeList=pageArr,
				this.page_index=pageArr[4]
			}
			this.getEquiplist()
		},
		// 下一页
		goBottom(){
			if(this.deviceCount==0){
			  return
			}
			if(this.page_index==this.pageSize){
			  this.$message.info(this.$t('mygd'))
			  return
			}
			this.page_index++;
			if(this.page_index>this.pageSizeList[4]){
				let pageArr = []
				this.pageSizeList.forEach(item=>{
				item+=5
				pageArr.push(item)
				})
				this.pageSizeList=pageArr,
				this.page_index=pageArr[0]
			}
			this.getEquiplist()
		},
        // 获取设备列表
        onLoad() {
            this.page_index++;
            this.getEquiplist()
        },
        getEquiplist(){
            let data={
                method:'co.wx.device.list',
                user_id:this.UserInfo.user_id,
                page_index:this.page_index,
                page_size:this.page_size,
                keyword:this.keyword
            }
            this.$serve(data).then(res=>{
                console.log(res)
                if(res.data.code==0){
                    this.equdatalist = res.data.data;
					this.deviceCount = res.data.count;
					this.pageSize = Math.ceil(res.data.count/this.page_size);
                    this.loading = false;
                    this.count = res.data.count
                    if (res.data.data == [] || this.count.length === 0) {
                        // 加载结束
                        this.finished = true;
                        return;
                    }
                    // this.equdatalist = this.equdatalist.concat(res.data.data)
                    
                    if (this.equdatalist.length >= this.count) {
                        this.finished = true;
                    }
                }
            })
        },
        // 查询
        questlist(){
            this.getEquiplist()
        }
    }
}
</script>
<style scoped>
	.data-load-more{
		width: 100%;
		height: 50px;
		line-height: 50px;
		background-color: #eee;
		text-align: center;
		font-size: 14px;
		display: flex;
		justify-content: space-between;
		margin-top: 20px;
	}
	.pageSizeBox{
		width: 50%;
		display: flex;
		justify-content: space-around;
	}
	.pageSizeItem{
	  width: 50rpx;
	}
	.pageSizeItemState{
	  color: #ff2146;
	  text-decoration: underline;
	}
.requist{
    width: 80%;
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-around;
}
.requist >>> .van-cell{
    width: 180px;
    border: 1px solid #ccc;
    padding: 4px 6px;
    border-radius:4px ;
}
.equtcont{
    margin: 0 auto;
    width: 80%;
    /* border-left: 5px solid #C280FF; */
}
.equtcont h4 {
    text-align: left;
    margin-left:10px ;
}
.costplas{
    /* margin-left: 10px; */
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    margin-top: 15px;
}
.yuan{
    /* margin: 0 auto; */
     width: 60px;
    height: 60px;
    border-radius:50% ;
    line-height: 70px;
    text-align: center;
    font-size: 38px;
    
}
.colors{
    color: #ccc;
    border: 1px solid #ccc;
}
.colorsold{
    color: #1ABC9C;
    border: 1px solid #1ABC9C;
}
.cents >>>.van-nav-bar__title{
    color: #fff;
}
.cents>>>.van-nav-bar .van-icon{
    color: #fff;
}
.cents>>>.van-nav-bar .van-nav-bar__text{
		color: #fff;
		font-size: 15px;
	}
</style>